module.exports = __webpack_public_path__ + "img/price-3.a8e05918.png";